// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1e19v","itemTitle":"ClientEmergencyInfo_itemTitle__2mVW7","itemText":"ClientEmergencyInfo_itemText__3ttt7"};